import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { api, imageUrl } from "../lib/api";

export function GuidesBlock({ city }) {
  const [guides, setGuides] = useState([]);
  useEffect(() => { api.get("/guides").then((r) => setGuides(r.data || [])).catch(console.error); }, []);
  if (!guides.length) return null;
  return (
    <section data-testid="guides-block" className="mb-10">
      <div className="flex items-end justify-between gap-3 mb-4">
        <div>
          <p className="text-neon-magenta text-xs uppercase font-bold tracking-widest mb-1 flex items-center gap-1.5"><BookOpen className="h-3.5 w-3.5" /> Guides CBD</p>
          <h2 className="font-anton text-2xl sm:text-3xl uppercase text-white">Bien choisir {city ? `avant de commander à ${city}` : "ton CBD"}</h2>
        </div>
        <Link to="/blog" data-testid="guides-all-link" className="hidden sm:inline-flex items-center gap-1 text-xs uppercase font-bold text-zinc-400 hover:text-neon-green">Tous les articles <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      <div className="flex gap-3 overflow-x-auto no-scrollbar scroll-fade-x -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-2 lg:grid-cols-5 sm:overflow-visible sm:[mask-image:none]">
        {guides.map((g) => (
          <Link key={g.slug} to={`/blog/${g.slug}`} data-testid="guide-card" className="group shrink-0 w-64 sm:w-auto bg-ink-surface border border-zinc-800 hover:border-neon-green transition-colors flex flex-col">
            <div className="aspect-[16/10] overflow-hidden bg-ink">
              <img src={imageUrl(g.image_url)} alt={g.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-3 flex flex-col flex-1">
              <h3 className="text-white font-semibold text-sm leading-snug line-clamp-2 group-hover:text-neon-green transition-colors">{g.title}</h3>
              <p className="text-zinc-500 text-xs mt-1.5 line-clamp-2 flex-1">{g.excerpt}</p>
              <span className="text-zinc-600 text-[11px] mt-2">{g.reading_minutes} min de lecture</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
